import { ToggleBodyClass } from '../helpers';

const buttons = document.querySelectorAll('[data-sublevel]');
const mastHead = document.querySelector('.m-masthead');

function initSublevelHandling() {
  const span = document.querySelector('#sublevel-anchor span');
  const backButton = document.querySelector('#sublevel-anchor');
  let targetEl = null;

  function handleSpanClick() {
    ToggleBodyClass('is-sublevel-active');
    targetEl.classList.remove('is-visible');
  }

  function handleClick({ target }) {
    targetEl = document.getElementById(`mobile-${target.dataset.sublevel}`);
    targetEl.classList.add('is-visible');
    span.innerHTML = target.innerText;
    ToggleBodyClass('is-sublevel-active');

    targetEl.style.overflowY = 'hidden';
    setTimeout( function () {
      targetEl.style.overflowY = 'scroll';
    }, 30);
  }

  [].map.call(buttons, button => button.addEventListener('click', handleClick));

  backButton.addEventListener('click', handleSpanClick);
}

function initSublevelKids() {
  const childButtons = document.getElementsByClassName('m-mobile-nav-sublevel__toggle');

  function handleClick({ currentTarget }) {
    currentTarget.parentElement.classList.toggle('is-open');
  }

  [].map.call(childButtons, button => button.addEventListener('click', handleClick));
}

if (mastHead && buttons.length) {
  initSublevelHandling();
  initSublevelKids();
}
